module.exports = __webpack_public_path__ + "static/media/Group 25.afd74ec3.svg";